export default {
  meta: {
    title: '机会点',
    url: '/locxx/opportunity',
    parentPath: ['/locxx'],
    breadcrumbs: {
      path: ['/locxx/opportunity'],
      name: ['机会点'],
    },
  },
};
